import { Authenticator, } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import backgroundImage from '../media/splash_bg.jpeg'

const SignIn = (props) => {
  return (
  <div className='w-100 vh-100 flex items-center justify-center' style={{
    backgroundImage: 'url(' + backgroundImage + ')', 
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'}}>
      <div className='flex flex-column items-center white '>
        <div className='f3 fw7 pb4'>Welcome to Evonik Claims Manager</div>
        <Authenticator hideSignUp={true}>
          {({ signOut, user }) => (
            <main>
              <button onClick={signOut}>Sign out</button>
            </main>
          )}
        </Authenticator>
      </div>
  </div>
)};

{/* <AmplifySignIn headerText='Welcome to Evonik Claim Manager' slot="sign-in" hideSignUp></AmplifySignIn> */}

export default SignIn